// extracted by mini-css-extract-plugin
export default {"root":"UsersGroupsTable_root__9OJaO","row":"UsersGroupsTable_row__O-+L3","boxMargin":"UsersGroupsTable_boxMargin__yl9wy","fullHeight":"UsersGroupsTable_fullHeight__xC6BS"};